import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter} from 'react-router-dom';

import DatabaseService from 'services/DatabaseService.js';
import {initNavbarState, setNavbarTitle} from 'actions/navbar.js';
import {fetchCategories} from 'actions/categories.js';
import {addChallenge} from 'actions/challenges.js';
import {getCategory} from 'reducers/categories.js'
import {NavControl} from 'modules/navigation/NavBarContainer.js';
import Sections from './Sections.js';
import Challenge from 'modules/challenges/Challenge.js';
import defaultChallengeImage from 'img/default-challenge-image.jpg';

class SectionsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {busy:false, sections:[], userCategory:null, selectedChallengeId:null};
        this.getChallengeImageUrl = this.getChallengeImageUrl.bind(this);
        this.onEditCategory = this.onEditCategory.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onLaunchChallenge = this.onLaunchChallenge.bind(this);
        this.onCloseChallenge = this.onCloseChallenge.bind(this);
        this.onChallengeContinue = this.onChallengeContinue.bind(this);
    }
    componentWillMount() {
        this.initNavigation();
        this.loadData();
    }
    
    initNavigation() {
        var title = '';
        if(this.props.category) {
            title = this.props.category.title;
        }
        this.props.dispatch(initNavbarState({enable:true, title:title, menuEnable:false, backButtonEnable:true, rewardsEnable:false}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.category!==nextProps.category) {
            var title = '';
            if(nextProps.category) {
                title = nextProps.category.title;
            }
            this.props.dispatch(setNavbarTitle(title));
        }
    }

    loadData() {
        var categoryId = this.props.match.params.id;
        this.setState({busy:true});
            this.props.loadData(categoryId)
            .then((result)=>{
                var sectionResult = result[1];
                var sections = sectionResult.sections;
                this.setState({userCategory:sectionResult.userCategory,
                               sections:sections});
            })
            .catch((error)=> {
                console.error('ERROR:');
                console.error(error);
            })
            .then(()=>{
                this.setState({busy:false});
            });
    }
    getChallengeImageUrl(challenge) {
        if(challenge.image && (challenge.image.url||'').length>0) {
            return challenge.image.url;
        } else {
            return defaultChallengeImage;
        }
    }

    onEditCategory() {
        this.props.history.push('/categories/'+this.props.match.params.id+'/1');        
    }

    onClose() {
        this.props.history.goBack();
    }

    onCloseChallenge() {
        this.setState({selectedChallengeId:null}); 
        this.initNavigation();
    }

    onChallengeContinue() {
        this.onCloseChallenge();
        this.loadData();
    }

    onLaunchChallenge(challenge) {
        this.setState({selectedChallengeId:challenge.id}); 
    }

    render() {
        if(this.state.selectedChallengeId) {
            return (
                <NavControl key="challenge" onClose={this.onCloseChallenge}>
                    <Challenge challengeId={this.state.selectedChallengeId}
                               onContinue={this.onChallengeContinue} />
                </NavControl>
            );
        } else {
            return (
                <NavControl key="sections" onDone={this.onEditCategory} onClose={this.onClose} doneIconOpts={{key:'1', className:'icon-settings'}}>
                    <Sections 
                        busy={this.state.busy}
                        userCategory={this.state.userCategory}
                        sections={this.state.sections}
                        getChallengeImageUrl={this.getChallengeImageUrl}
                        onLaunchChallenge={this.onLaunchChallenge} />
                </NavControl>
                );
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return { category:getCategory(state.categories, ownProps.match.params.id) };
};
const mapDispatchToProps = (dispatch) => {
    return {
        loadData: (categoryId) => { 
            return Promise.all([
                dispatch(fetchCategories()),
                DatabaseService.fetchCategorySections(categoryId)]);
        },
        dispatch: dispatch
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SectionsContainer));



// WEBPACK FOOTER //
// ./src/modules/categories/SectionsContainer.js